// extracted by mini-css-extract-plugin
export default {"neonButton":"W7qX5ViI","_disabled":"h3FmC7xf","borders":"mF_FhzLc","content":"RdiGabUg"};